import React from "react";

import type { ProcessedEntry } from "@/hooks/firestore/betting/useEntries";
import type { CashOutProps } from "../types/entries";

import { isBetEntry, isPickemsEntry } from "../util/type-guards";
import { BetEntry } from "./bets/BetEntry";
import { PickemEntry } from "./pickems/PickemEntry";
import { hasTrackableBets } from "../util/bet-tracker-helpers";
import { ImpressionTrackingConsumer } from "@picklebet/telemetry/react";

interface EntryProps {
  entry: ProcessedEntry;
  cashOut?: CashOutProps;
  isCompact?: boolean;
  isPreview?: boolean;
}

const Entry = ({
  entry,
  cashOut,
  isCompact = false,
  isPreview = false,
}: EntryProps) => {
  if (isBetEntry(entry)) {
    const betEntry = (
      <BetEntry
        entry={entry}
        cashOut={cashOut}
        isCompact={isCompact}
        isPreview={isPreview}
      />
    );

    if (hasTrackableBets(entry) && entry.status === "live") {
      return (
        <ImpressionTrackingConsumer event="betTrackerViewed" dwellMs={15_000}>
          {betEntry}
        </ImpressionTrackingConsumer>
      );
    }

    return betEntry;
  }

  if (isPickemsEntry(entry)) {
    return <PickemEntry entry={entry} />;
  }

  return null;
};

export { Entry };
